module.exports = __webpack_public_path__ + "img/Modernisme_Norske_lyrikere5.464d05c2.jpg";